export default {"src":"/_next/static/media/lose.9c1b31dd.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};